module.exports = __webpack_public_path__ + "static/stars_bg-fc6d4d56a7b6af1987cb27073e695f8b.jpg";